import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-verticals-banner',
    templateUrl: './verticals-banner.component.html',
    styleUrls: ['./verticals-banner.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VerticalsBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
